import React from "react";
import AttachmentPreviewSkeleton from "./PreviewSkeleton";

type AudioPreviewProps = {
  fileUrl?: string;
  fileName?: string;
  zoomLevel?: number;
};

const AudioPreview: React.FC<AudioPreviewProps> = ({
  fileUrl,
  fileName,
  zoomLevel = 100,
}) => {
  const [isReady, setIsReady] = React.useState(false);
  const [hasLoadError, setHasLoadError] = React.useState(false);

  React.useEffect(() => {
    setIsReady(false);
    setHasLoadError(false);
  }, [fileUrl]);

  if (!fileUrl) {
    return <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />;
  }

  if (hasLoadError) {
    return <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />;
  }

  return (
    <main className="h-full min-h-0 w-full bg-gray-100 overflow-auto">
      <div className="h-full w-full flex items-center justify-center p-6">
        <div className="relative w-full flex flex-col items-center justify-center gap-4 p-6">
          {!isReady ? (
            <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-100">
              <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />
            </div>
          ) : null}
          {fileName ? (
            <p className="w-full truncate text-center text-sm text-black">
              {fileName}
            </p>
          ) : null}
          <div className="w-full">
            <audio
              key={fileUrl}
              className="w-full"
              controls
              preload="metadata"
              src={fileUrl}
              onLoadedData={() => setIsReady(true)}
              onError={() => {
                setHasLoadError(true);
                setIsReady(false);
              }}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default AudioPreview;
